import { useState, useEffect } from "react";

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newService, setNewService] = useState({
    name: "",
    duration_minutes: "",
    color_code: "#000000",
  });

  const [editingService, setEditingService] = useState(null);

  useEffect(() => {
    fetch("https://api.remindly.gr/get-services.php", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setServices(data);
        setLoading(false);
      });
  }, []);

  async function addService(e) {
    e.preventDefault();

    const res = await fetch("https://api.remindly.gr/add-service.php", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newService),
    });

    const result = await res.json();

    if (result.success) {
      setServices([...services, result.service]);
      setNewService({ name: "", duration_minutes: "", color_code: "#000000" });
    } else {
      alert("Failed to add service");
    }
  }

  async function updateService(updated) {
    const res = await fetch("https://api.remindly.gr/update-service.php", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updated),
    });

    const result = await res.json();

    if (result.success) {
      setServices(
        services.map((s) => (s.id === updated.id ? updated : s))
      );
      setEditingService(null);
    } else {
      alert("Failed to update service");
    }
  }

  async function toggleActive(service) {
    const updated = { ...service, active: service.active ? 0 : 1 };

    const res = await fetch(
      "https://api.remindly.gr/toggle-service-active.php",
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: updated.id,
          active: updated.active,
        }),
      }
    );

    const result = await res.json();

    if (result.success) {
      setServices(
        services.map((s) => (s.id === updated.id ? updated : s))
      );
    } else {
      alert("Failed to update status");
    }
  }

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Services</h2>

      <form onSubmit={addService} className="mb-6 space-y-2">
        <input
          type="text"
          placeholder="Service name"
          className="border p-2 w-full"
          value={newService.name}
          onChange={(e) =>
            setNewService({ ...newService, name: e.target.value })
          }
        />

        <input
          type="number"
          placeholder="Duration (minutes)"
          className="border p-2 w-full"
          value={newService.duration_minutes}
          onChange={(e) =>
            setNewService({
              ...newService,
              duration_minutes: e.target.value,
            })
          }
        />

        <input
          type="color"
          className="border p-2 w-full"
          value={newService.color_code}
          onChange={(e) =>
            setNewService({
              ...newService,
              color_code: e.target.value,
            })
          }
        />

        <button className="bg-blue-500 text-white p-2 rounded">
          Add Service
        </button>
      </form>

      {loading ? (
        <p>Loading services...</p>
      ) : (
        <div className="space-y-2">
          {services.map((service) => (
            <div
              key={service.id}
              className="border p-4 flex justify-between items-center"
              style={{ backgroundColor: service.color_code }}
            >
              <div>
                <p className="font-bold">{service.name}</p>
                <p>{service.duration_minutes} mins</p>
                <p>{service.active ? "Active" : "Inactive"}</p>
              </div>

              <div className="space-x-2">
                <button
                  className="bg-yellow-500 text-white px-3 py-1 rounded"
                  onClick={() => setEditingService(service)}
                >
                  Edit
                </button>

                <button
                  className="bg-green-500 text-white px-3 py-1 rounded"
                  onClick={() => toggleActive(service)}
                >
                  Toggle
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
